<template lang="html">
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg9>
          <p class="table_card__head--title">Crear categoría</p>
          <v-breadcrumbs class="breadcums">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item
              @click="$router.push({name: 'category'})"
              class="breadcums__option"
            >
              Categorías
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              disabled
              class="breadcums__disable"
            >
              Nueva categoría
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <v-flex lg3 class="filter_options">
          <v-flex class="right mr-1">
            <button
              class="faccess_button px-5"
              @click="createCategory()"
            >
              Crear
            </button>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body">
      <v-flex lg7 xs12>
        <span class="table_card__info--label">Nombre</span>
        <input
          class="faccess_input"
          type="text"
          placeholder="Nombre de la categoría"
          v-model="category.attributes.name"
        >
      </v-flex>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      is_sub:false,
      category:{
        attributes:{
          name: '',
          is_parent: false,
          published: true,
          parent_category_id: null,
          company_id:this.getCompany().id
        }
      },
      parent_category:{attributes:{name: ''}, id: null}
    }
  },
  mounted(){
    this.findCategories()

  },
  methods:{
    createCategory(){
      if(this.category.attributes.name!=''){
        this.category.attributes.is_parent=!this.category.attributes.is_sub;
        if(this.category.attributes.name != '' &&
           this.category.attributes.name != undefined &&
           this.category.attributes.name != null){
          if(this.parent_category.id != null){
            this.category.attributes.parent_category_id = this.parent_category.id
          }
          try {
            this.$http.post('categories', {data: this.encrypt(this.category).toString()},
            {headers:
              {"X-Device-ID" : this.getDeviceId(),
               "Authorization" : 'Bearer ' + this.getUserToken()}}
          ).then(function(response){
              this.$router.push({name: 'category'})
              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            }, function(response){
              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
              if(typeof response.body.errors[0].details != "object"){
                alert(response.body.errors[0].details);
              }else{
                let message = []
                for(var key in response.body.errors[0].details){
                  message.push(response.body.errors[0].details[key])
                }
                alert(message);
              }
            })
          } catch (e) {
            alert(e.message)
          }
        }
      }

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/categories/New_category.vue